import {
  Component,
  Inject,
  signal
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { PatientService } from '../../../services/patient.service';
import { AuthService } from '../../../services/auth.service';
import { DoctorService } from '../../../services/doctor.service';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-requisition-builder-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatTabsModule,
    MatIconModule,
    MatCheckboxModule,
    MatInputModule,
    CommonModule,
    FormsModule,
    MatTabsModule,
    MatIconModule,
    MatCheckboxModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule
  ],
  templateUrl: './requisition-builder-dialog.component.html',
  styleUrls: ['./requisition-builder-dialog.component.scss']
})
export class RequisitionBuilderDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RequisitionBuilderDialogComponent>,
    private patientService: PatientService, private authService: AuthService, private doctorService: DoctorService, private dialog: MatDialog, private toastr: ToastrService,


    @Inject(MAT_DIALOG_DATA)
    public patient: any
  ) {


  }

  templateName = 'Default Template';

  searchBox = '';
  comments = '';
  selectedTest: string[] = [];
  selectedTemplate: any[] = [];
  alltest: any[] = [];
  selectedAllTests: string[] = [];

  selectedPackageTests: {
    [packageName: string]: string[]
  } = {};
  filteredPackageWiseTests: any = {};

  allRequistionTest: any[] = [];
  isRequisitionsLoading: boolean = false;
  userId: any;
  requisitionURL: string = '';

  loading = signal(false);

  sectionWiseRequisitionTests: any[] = [];
  filteredSectionWiseRequisitionTests: any[] = [];
  currentDoctorObj: any = {};

  packageWiseTests: any = {};


  objectKeys = Object.keys;
  patientFullName = '';
  patientUHID = '';

  ngOnInit(): void {
    this.loading.set(true);


    console.log('RAW DATA', this.patient);
    this.userId = this.authService.getUser();

    const row = this.patient?.patient;

    // Requisition table row
    if (row?.patientName) {

      this.patientFullName =
        row.patientName
          .replace(/\n/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();

      this.patientUHID =
        row.patientId;

    }

    // Patient selection dialog
    else if (row?.firstName) {

      this.patientFullName =
        [
          row.firstName,
          row.middleName,
          row.lastName
        ]
          .filter(Boolean)
          .join(' ')
          .trim();

    }

    console.log(
      'patientFullName',
      this.patientFullName
    );

    this.getAllRequiredConstants();
    this.getDoctorDetails();

  }
  private rebuildSelectedTests(): void {
    const result: string[] = [];
    this.selectedAllTests.forEach(
      (test: string) => {

        if (!result.includes(test)) {

          result.push(test);

        }

      }
    );
    Object.values(
      this.selectedPackageTests
    ).forEach(
      (tests: string[]) => {

        tests.forEach(
          (test: string) => {

            if (!result.includes(test)) {

              result.push(test);

            }

          }
        );

      }
    );


    this.selectedTest =
      result;

  }

  isPackageSelected(packageName: string): boolean {

    const packageTests =
      this.packageWiseTests[packageName] || [];

    if (!packageTests.length) {
      return false;
    }

    return packageTests.every(
      (item: any) =>
        this.selectedTest.includes(item.test)
    );
  }

  isPackageTestSelected(
    packageName: string,
    testName: string
  ): boolean {

    return this.selectedTest.includes(testName);
  }

  getSelctedTest(
    packageName: string,
    event: any
  ): void {

    const checked = event.checked;

    const packageTests =
      this.packageWiseTests[packageName] || [];

    if (!packageTests.length) {
      return;
    }

    const packageTestNames =
      packageTests.map(
        (item: any) => item.test
      );
    if (checked) {

      packageTestNames.forEach(
        (testName: string) => {

          if (
            !this.selectedTest.includes(testName)
          ) {

            this.selectedTest.push(testName);

          }

        }
      );

    }
    else {

      this.selectedTest =
        this.selectedTest.filter(
          (testName: string) =>
            !packageTestNames.includes(testName)
        );

    }


    // Create new array reference
    // so Angular updates the UI
    this.selectedTest = [
      ...this.selectedTest
    ];

    console.log(
      'SELECTED TESTS AFTER PACKAGE:',
      this.selectedTest
    );

  }
  getDoctorDetails() {

    const params = {

      user_id: this.userId

    };

    this.doctorService
      .getDetails(params)
      .subscribe({

        next: (response: any) => {

          console.log(
            "Current Doctor",
            response
          );

          if (!response?.doctor) {
            return;
          }

          this.currentDoctorObj =
            response.doctor;
          console.log("currentDoctorObj", this.currentDoctorObj);


          try {

            const services =
              JSON.parse(
                this.currentDoctorObj.services || '{}'
              );

            console.log(
              "Doctor Services",
              services
            );

            if (
              services?.template_names?.length
            ) {

              this.selectedTemplate =
                services.template_names;

              this.templateName =
                services.template_names[0];

            } else {

              this.selectedTemplate = [
                'Default'
              ];

              this.templateName =
                'Default';
            }

          } catch (e) {

            console.log(
              "Template Parse Error",
              e
            );

            this.selectedTemplate = [
              'Default'
            ];

            this.templateName =
              'Default';
          }
        },

        error: (err: any) => {

          console.log(
            "Doctor Details Error",
            err
          );

          this.selectedTemplate = [
            'Default'
          ];

          this.templateName =
            'Default';
        }

      });
  }
  getAllRequiredConstants() {

    let newArray: any[] = [];

    this.patientService
      .getAllRequiredConstants('')
      .subscribe((response: any) => {

        if (!response?.data) {
          return;
        }

        newArray =
          response.data.requisitionTests || [];

        this.alltest =
          newArray.map((ins: any, index: number) => ({
            name: ins.name,
            selected: false,
            id: index
          }));

        this.allRequistionTest =
          response.data.requisitionTestsFromDB || [];

        const arr =
          response.data.requisitionTestsFromDB || [];

        let sections: any[] = [];
        let otherTestArr: any[] = [];

        arr.forEach((element: any) => {

          if (element.section) {

            sections.push(element.section);

          } else {

            otherTestArr.push({
              name: element.testname,
              selected: false
            });

          }

        });

        sections = [...new Set(sections)];

        const finalArr: any[] = [];

        sections.forEach((section: any) => {

          const testArr =
            arr
              .filter(
                (x: any) =>
                  x.section === section
              )
              .map((x: any) => ({
                name: x.testname,
                selected: false
              }));

          finalArr.push({
            section,
            data: testArr
          });

        });

        finalArr.push({
          section: 'Others',
          data: otherTestArr
        });

        this.sectionWiseRequisitionTests =
          finalArr;
        this.filteredSectionWiseRequisitionTests =
          [...finalArr];
        this.loading.set(false);

        console.log(
          'SECTION TESTS',
          this.sectionWiseRequisitionTests
        );

        this.templateName =
          this.templateName || 'Default';

        this.getAllRequisitionsPackages();

      });

  }
  getAllRequisitionsPackages(): void {

    let finalTestArray: any[] = [];

    this.allRequistionTest.forEach((testObject: any) => {

      if (testObject.packages) {

        const packageArray =
          testObject.packages
            .split(',')
            .map((x: string) => x.trim())
            .filter(Boolean);

        packageArray.forEach((pkg: string) => {

          finalTestArray.push({
            package: pkg,
            test: testObject.testname,
            selected: false
          });

        });
      }
    });

    this.packageWiseTests =
      finalTestArray.reduce(
        (result: any, item: any) => {

          if (!result[item.package]) {
            result[item.package] = [];
          }

          result[item.package].push(item);

          return result;

        },
        {}
      );

    // Important: create filtered copy
    this.filteredPackageWiseTests =
      Object.keys(this.packageWiseTests)
        .reduce((result: any, key: string) => {

          result[key] = [
            ...this.packageWiseTests[key]
          ];

          return result;

        }, {});

    console.log(
      'PACKAGE TESTS',
      this.packageWiseTests
    );
  }
  onSearchChange(value: string): void {

    const search =
      (value || '').trim().toLowerCase();

    if (!search || search.length < 2) {

      this.filteredSectionWiseRequisitionTests =
        this.sectionWiseRequisitionTests.map(
          (section: any) => ({
            ...section,
            data: [...section.data]
          })
        );

    } else {

      this.filteredSectionWiseRequisitionTests =
        this.sectionWiseRequisitionTests

          .map((section: any) => ({

            ...section,

            data: section.data.filter(
              (test: any) =>
                test.name
                  ?.toLowerCase()
                  .includes(search)
            )

          }))

          .filter(
            (section: any) =>
              section.data.length > 0
          );
    }
    if (!search || search.length < 2) {

      this.filteredPackageWiseTests =
        Object.keys(this.packageWiseTests)
          .reduce(
            (result: any, key: string) => {

              result[key] = [
                ...this.packageWiseTests[key]
              ];

              return result;

            },
            {}
          );

    } else {

      this.filteredPackageWiseTests =
        Object.keys(this.packageWiseTests)
          .reduce(
            (result: any, key: string) => {

              const filteredTests =
                this.packageWiseTests[key]
                  .filter(
                    (item: any) =>
                      item.test
                        ?.toLowerCase()
                        .includes(search) ||
                      key
                        ?.toLowerCase()
                        .includes(search)
                  );

              if (filteredTests.length > 0) {

                result[key] = filteredTests;

              }

              return result;

            },
            {}
          );
    }


    console.log(
      'FILTERED ALL TESTS',
      this.filteredSectionWiseRequisitionTests
    );

    console.log(
      'FILTERED PACKAGES',
      this.filteredPackageWiseTests
    );
  }

  closeDialog(): void {
    this.dialogRef.close();
  }



  tabClick(event: any): void {
    console.log(event);
  }

  onDropdownSelectTemplate(template: string): void {
    this.templateName = template;
  }

  selectModalTestValue(test: any): void {

    if (!test?.name) {
      return;
    }

    const testName =
      test.name;

    const index =
      this.selectedAllTests.indexOf(
        testName
      );


    if (index > -1) {

      this.selectedAllTests.splice(
        index,
        1
      );

    } else {

      this.selectedAllTests.push(
        testName
      );

    }


    this.selectedAllTests =
      [...this.selectedAllTests];

    this.rebuildSelectedTests();
  }

  selectPackageTestValue(
    obj: any
  ): void {

    const testName =
      obj?.test;

    if (!testName) {
      return;
    }
    if (
      this.selectedTest.includes(testName)
    ) {

      this.selectedTest =
        this.selectedTest.filter(
          test => test !== testName
        );

    }
    else {

      this.selectedTest = [
        ...this.selectedTest,
        testName
      ];

    }


    console.log(
      'SELECTED TESTS AFTER SINGLE CLICK:',
      this.selectedTest
    );

  }


  removeSelectedTest(
    item: string
  ): void {

    this.selectedTest =
      this.selectedTest.filter(
        x => x !== item
      );
  }


  saveAndShare(): void {

    if (this.isRequisitionsLoading) {
      return;
    }


    if (this.templateName === 'Speciality') {

      alert(
        'Please specify speciality'
      );

      return;
    }


    if (!this.selectedTest.length) {

      this.toastr.warning(
        'Please select at least one test'
      );

      return;
    }


    this.isRequisitionsLoading = true;

    let testArr =
      [...this.selectedTest];

    testArr = testArr.reduce(
      (
        unique: any[],
        item: any
      ) => {

        if (
          !unique.includes(item)
        ) {
          unique.push(item);
        }

        return unique;

      },
      []
    );
    console.log("patient", this.patient);

    const patientId =
      this.patient?.patient._id ||
      this.patient?.id ||
      this.patient?.patientId || this.patient.patient.patientId;

    console.log(
      'PATIENT ID',
      patientId
    );

    if (!patientId) {

      this.isRequisitionsLoading =
        false;

      alert(
        'Patient not selected'
      );

      return;
    }

    const postData = {

      patient_id: patientId,

      doctorId:
        this.currentDoctorObj?.UserId ||
        this.userId,

      action: 'preview',

      type: 'Requisition',

      tests:
        [...new Set(this.selectedTest)]
          .join('| '),

      comments:
        this.comments || '',

      templateName:
        this.templateName
    };
    console.log(
      'PRINT POST DATA',
      postData, this.currentDoctorObj
    );
    // return;
    this.patientService
      .printRequisitions(postData)
      .subscribe({

        next: (response: any) => {


          console.log(
            'PRINT RESPONSE',
            response
          );

          if (
            !response ||
            !response.url
          ) {

            alert(
              'Requisition generation failed'
            );

            return;
          }

          const requisitionUrl =
            response.url;

          this.requisitionURL =
            requisitionUrl;

          this.shareWithPatient(
            patientId,
            requisitionUrl
          );

          this.shareWithLab(
            patientId,
            requisitionUrl
          );
          this.toastr.success(
            'Requisition generated and shared successfully'
          );


        },

        error: (error: any) => {

          this.isRequisitionsLoading = false;

          console.log(
            'PRINT ERROR',
            error
          );

        }

      });

  }
  shareWithPatient(
    patientId: any,
    requisitionUrl: string
  ) {

    const postData = {

      patient_id: patientId,

      url: requisitionUrl

    };

    this.patientService
      .shareRequisition(postData)
      .subscribe({

        next: (res: any) => {

          console.log(
            'PATIENT SHARE SUCCESS',
            res
          );


        },

        error: (err: any) => {

          console.log(
            'PATIENT SHARE ERROR',
            err
          );

        }

      });

  }
  shareWithLab(
    patientId: any,
    requisitionUrl: string
  ) {

    const labDetails =
      JSON.parse(
        localStorage.getItem(
          'LAB_DETAILS'
        ) || '{}'
      );

    const postData = {

      patient_id: patientId,

      lab: {

        id: labDetails.id,

        updatedAt:
          labDetails.updatedAt,

        createdAt:
          labDetails.createdAt,

        address:
          labDetails.address,

        contactNo:
          labDetails.contactNo,

        email_id:
          labDetails.email_id,

        name:
          labDetails.name,

        status:
          labDetails.status,

        waNo:
          labDetails.waNo?.includes(
            '+91'
          )
            ? labDetails.waNo
            : '+91' +
            labDetails.waNo

      },

      url: requisitionUrl

    };

    console.log(
      'LAB SHARE POST DATA',
      postData
    );

    this.patientService
      .shareRequisitionWithLab(
        postData
      )
      .subscribe({

        next: (res: any) => {

          console.log(
            'LAB SHARE SUCCESS',
            res
          );

          this.selectedTest = [];
          this.comments = '';


          this.closeAndRefresh();
          this.isRequisitionsLoading = false;





        },

        error: (err: any) => {

          this.isRequisitionsLoading =
            false;

          console.log(
            'LAB SHARE ERROR',
            err
          );

        }

      });

  }
  closeAndRefresh() {

    console.log(
      'CLOSING REQUISITION'
    );

    this.dialogRef.close({
      refresh: true
    });

  }
}